import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { log } from "./log";

function SmsPage() {
  const { id } = useParams<{ id?: string }>();

  useEffect(() => {
    if (id) {
      log('o_corp_huasheng_onlinehome_redirect_sms', {id}, { isTrace: false });
      window.location.href = `https://t.ctrip.cn/${id}`;
    }
  }, [id]);

  return null;
}

export default SmsPage;
